import { Button, Grid, Typography } from "@mui/material";
import Divider from "@mui/material/Divider";
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import ListItemText from "@mui/material/ListItemText";
import * as React from "react";
import { useNavigate, useParams } from "react-router-dom";
import { AppContext } from "../helpers/contexts/AppContext";
import useAxiosPrivate from "../hooks/useAxiosPrivate";
const style = {
  width: "100%",
  display: "flex",
  bgcolor: "background.paper",
  flexDirection: "column",
};

const { REACT_APP_ACCOUNTS_API_URL } = process.env;
const endpoint = "account-type";
const redirectUrl = "/account-types";

export default function Profile() {
  const [type, setType] = React.useState({});

  const { deleteAndRedirect } = React.useContext(AppContext);
  const navigate = useNavigate();
  const axios = useAxiosPrivate();
  const { id } = useParams();

  React.useEffect(() => {
    axios.get(`${REACT_APP_ACCOUNTS_API_URL}/${endpoint}/${id}`).then((res) => {
      const { result } = res.data;
      setType(result);
    });
  }, []);

  return (
    <Grid sx={{ display: "flex", flexDirection: "column" }}>
      <List sx={style} component="nav" aria-label="Profile Details">
        <ListItem button>
          <ListItemText primary="Account Type" />
          <Typography>{type.account_type}</Typography>
        </ListItem>
        <Divider />
        <ListItem button>
          <ListItemText primary="Max. Balance Limit" />
          <Typography>{type.maximum_balance_limit}</Typography>
        </ListItem>
        <Divider />
        <ListItem button>
          <ListItemText primary="Allowed Trans. Per Min" />
          <Typography>{type.allowed_transactions_per_min}</Typography>
        </ListItem>
        <Divider />
        <ListItem button>
          <ListItemText primary="Allowed Daily Deposits" />
          <Typography>{type.allowed_daily_deposits}</Typography>
        </ListItem>
        <Divider />
        <ListItem button>
          <ListItemText primary="Allowed Daily Withdrawals" />
          <Typography>{type.allowed_daily_withdrawals}</Typography>
        </ListItem>
        <Divider />
        <ListItem button>
          <ListItemText primary="Allowed Daily Transfer Ins" />
          <Typography>{type.allowed_daily_transfer_ins}</Typography>
        </ListItem>
        <Divider />
        <ListItem button>
          <ListItemText primary="Allowed Daily Transfer Outs" />
          <Typography>{type.allowed_daily_transfer_outs}</Typography>
        </ListItem>
        <Divider />
      </List>

      <Grid sx={{ mt: 2, justifyContent: "center" }}>
        <Button
          variant="outlined"
          sx={{ m: 0.5 }}
          aria-label="all-account-type"
          onClick={() => navigate(redirectUrl)}
        >
          View All Account Types
        </Button>
        <Button
          variant="outlined"
          sx={{ m: 0.5 }}
          aria-label="export-transactions"
          color="warning"
          onClick={() =>
            deleteAndRedirect(
              id,
              `${REACT_APP_ACCOUNTS_API_URL}/${endpoint}`,
              "Account Type",
              true,
              navigate,
              redirectUrl
            )
          }
        >
          Delete This Account Type
        </Button>
      </Grid>
    </Grid>
  );
}
